import Vue from 'vue'
import Router from 'vue-router'
import Privacy from '@/components/Privacy'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Privacy',
      component: Privacy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js